import axios from 'axios';

export default axios.create({
    baseURL: `${process.env.RAZZLE_API}/api/v1/foundation/content`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    }
});
